import { useCallback } from 'react';

const errorMessageMaps: { [key: string]: string } = {
  invalid_address_format: 'Invalid address',
  invalid_amount: 'Invalid amount',
  greater_than_balance: 'Invalid amount',
  less_or_equal_than_minimum: 'Insufficient balance to cover gas fee',
  missing_amount: 'Invalid amount',
  missing_destination_address: 'Please input an address',
  missing_token: 'Please select an asset',
};

function useGetErrorMessage(): (key: string) => string {
  return useCallback((key: string): string => errorMessageMaps[key] ?? '', []);
}

export default useGetErrorMessage;
